var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "upload-image-component",
        { "u-disabled": !_vm.isAllowToSelectFile }
      ],
      attrs: { title: _vm.unableUploadTitle },
      on: {
        click: _vm.onClick,
        drop: function($event) {
          $event.preventDefault()
          return _vm.onDrop.apply(null, arguments)
        },
        dragover: function($event) {
          $event.preventDefault()
          _vm.dragover = true
        },
        dragleave: function($event) {
          $event.preventDefault()
          _vm.dragover = false
        }
      }
    },
    [
      _c("input", {
        ref: "fileInput",
        attrs: { type: "file", accept: ".jpeg, .jpg, .png" },
        on: {
          change: function($event) {
            return _vm.selectionProcessing($event)
          }
        }
      }),
      _vm._v(" "),
      Object.keys(_vm.processing_errors).length > 0 ||
      _vm.image.status === "INITIATED"
        ? _c("div", [_vm._m(0)])
        : _vm.image.status === "CHECKING"
        ? _c("div", [_vm._v("Checking...")])
        : _vm.image.status === "UPLOADING"
        ? _c("div", [_vm._v(_vm._s(_vm.image.upload_percentage) + "%")])
        : ["COMPLETE"].includes(_vm.image.status)
        ? _c("div", [_vm._v("Complete")])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-image-title" }, [
      _c("b", [_vm._v("Upload")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }